import { useMemo } from 'react';
import PageLoader from 'app/components/PageLoader';
import {
  isPackageRow,
  makePackageAwareColumns,
  PackageMembers,
} from 'app/components/PackageRow';
import PackageCollectPanel from 'app/components/PackageCollectPanel';
import PaginatedTable from 'app/components/table/PaginationTable';
import { CustomerVouchersHeader } from 'app/constants/table-header-constants';
import useCustomerVouchers from './useCustomerVouchers';
import CollectVoucher from './CollectVoucher';

// The expandable member list under a package row is kept but switched off
// (client request, 2026-10-12): package rows show no expand arrow.
const SHOW_PACKAGE_MEMBER_ROWS = false;

const CollectionPanel = () => {
  const {
    fetchCustomerData,
    totalNumber,
    filteredData,
    changeHandler,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    navigate,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    handleSubmit,
    handleNew,
    customerData,
    handleDelete,
    setCurrentPage,
    selectedVoucher,
    setSelectedVoucher,
    packageCollect,
  } = useCustomerVouchers();

  // Memoised: PaginationTable memoises on the columns array identity, so a fresh
  // array every render would loop its fetch effect.
  const columns = useMemo(
    () => makePackageAwareColumns(CustomerVouchersHeader),
    []
  );

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={columns}
          data={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          changeHandler={changeHandler}
          pageLoading={pageLoading}
          navigate={navigate}
          handleNew={handleNew}
          handleDelete={handleDelete}
          customerData={customerData}
          fetchData={fetchCustomerData}
          setCurrentPage={setCurrentPage}
          canExpandRow={SHOW_PACKAGE_MEMBER_ROWS ? isPackageRow : undefined}
          renderSubRow={
            SHOW_PACKAGE_MEMBER_ROWS
              ? (row) => <PackageMembers vouchers={row?.vouchers} />
              : undefined
          }
        />
      </div>

      {isFilterOpen && (
        <CollectVoucher
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          onSubmit={handleSubmit}
          values={values}
          setValues={setValues}
          voucherId={selectedVoucher?.voucherId}
        />
      )}

      {/* Page-level sibling: both drawers render their own <form>. */}
      <PackageCollectPanel
        lines={packageCollect.lines}
        phoneNumber={packageCollect.phoneNumber}
        isOpen={packageCollect.isOpen}
        setIsOpen={packageCollect.setIsOpen}
        onLineChange={packageCollect.handleLineChange}
        onSubmit={packageCollect.handleSubmit}
      />

      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CollectionPanel;
